import React from "react"

const PrivacyPolicy: React.FC = (): React.ReactElement => {

  return (
    <a href="https://prismancy.com/policy/privacy" className="type-link border-0 p-0 m-0" target="_blank" rel="noreferrer">Privacy Policy</a>
  )
}

export default PrivacyPolicy
